export default __webpack_public_path__ + "static/media/collect.73da04ec.svg";